<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <div class="operate">
      <div class="search">
        <b-form-select
          v-model="search.class"
          :options="options.class"
        ></b-form-select>

        <b-form-select v-model="search.plan" :options="options.plan">
          <template #first>
            <b-form-select-option :value="null" disabled>-- 組別 --</b-form-select-option>
            <b-form-select-option value="">全部</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select v-model="search.receive" :options="billReceiveMethod">
          <template #first>
            <b-form-select-option :value="null" disabled>-- 領取方式 --</b-form-select-option>
            <b-form-select-option value="">全部</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-model="search.bill_type"
          :options="billType"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 帳單類型 --</b-form-select-option>
            <b-form-select-option value="">全部</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-select
          v-model="search.member_status"
          :options="options.member_status"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>-- 契約狀態 --</b-form-select-option>
            <b-form-select-option value="">全部</b-form-select-option>
          </template>
        </b-form-select>

        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="search.number"
          @keyup.enter="getBillFlatten(1)" />

        <b-form-input
            placeholder="關鍵字"
            v-model="search.blur"
            @keyup.enter="getBillFlatten(1)" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="search.sales_number"
          @keyup.enter="getBillFlatten(1)" />

        <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務身分證"
          v-model="search.sales_ID_number"
          @keyup.enter="getBillFlatten(1)" />

        <!-- <b-form-input
          v-if="status.moreFilter"
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="期別"
          v-model="search.period"
          @keyup.enter="getBillFlatten(1)" /> -->

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_date_S"
          :position="'right'"
          placeholder="銷帳時間開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.pay_date_E"
          :position="'right'"
          placeholder="銷帳時間結束"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_date_S"
          :position="'right'"
          placeholder="帳單繳費期限開始"
        ></date-picker>

        <date-picker
          v-if="status.moreFilter"
          v-model="search.dead_date_E"
          :position="'right'"
          placeholder="帳單繳費期限結束"
        ></date-picker>

        <b-button
          @click="status.moreFilter = !status.moreFilter"
          variant="info"
        >
          {{ status.moreFilter ? '較少' : '更多' }}篩選
        </b-button>
      </div>

      <div class="btn-area">
        <div class="btn-function">
          <b-button variant="danger" @click="resetSearch()">重置</b-button>

          <b-button variant="success" @click="getBillFlatten(1)">搜尋</b-button>
        </div>
      </div>

    </div>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getBillFlatten"
      tableId="payDetails"
    >
      <template #cell(no)="row">
        {{ countNoNum(data.page, row.index) }}
      </template>

      <template #cell(type)="row">
        <span :class="getBillTypeColor(row.item.type)">{{ getBillFeeDescription(row.item) }}</span>
      </template>

      <template #cell(dead_line)="row">
        {{ convertRocDate(row.item.dead_line, false) }}
      </template>

      <template #cell(payment_at)="row">
        {{ convertRocDate(row.item.payment_at, false) }}
      </template>

      <template #cell(bill_updated_at)="row">
        {{ convertRocDate(row.item.bill_updated_at, false) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          @click="generateBill(row.item)"
        >
          下載帳單
        </b-button>
      </template>
    </tables-page>

    <html-to-pdf
      v-if="status.resetDom"
      ref="htmlToPdf"
      @handlerCompleted="pdfCompleted"
    >
      <template slot="pdf-content">
          <bill :data="data.temp_table_data" :multipleDetails="false"></bill>
      </template>
    </html-to-pdf>

  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import billApi from "@/models/API/billApi";
import HtmlToPdf from '@/components/common/HtmlToPdf';
import Bill from '@/components/common/PrintTemplate/Bill';
import { convertRocDate, countNoNum, getBillTypeColor, getBillFeeDescription } from "@/models/HELPERS/common.js";
import { billReceiveMethod, billType } from "@/models/HELPERS/options.js";
import datePicker from '@/components/common/DatePicker';

export default {
  name: 'payDetails',
  components: {
    BreadCrumb,
    TablesPage,
    Bill,
    HtmlToPdf,
    datePicker
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '帳單管理', url: '', isActive: true },
          { name: '繳費細項', url: '', isActive: false }
        ]
      },
      options: {
        class: [
          { value: 0, text: '已繳' },
          { value: 1, text: '未繳' },
          { value: 2, text: '壞帳' },
          { value: 3, text: '復會前已繳' }
        ],
        plan: [
          { value: 'A', text: 'A' },
          { value: 'B', text: 'B' },
        ],
        type: [
          { value: 0, label: '全部', key: '' },
          { value: 1, label: '月費', key: 'M' },
          { value: 2, label: '平台年費', key: 'Y' },
          { value: 3, label: '手續費', key: 'F' },
          { value: 4, label: '回饋金', key: 'S' },
          { value: 5, label: '墊繳手續費', key: 'B' }
        ],
        member_status: [
          { value: 0, text: '正常' },
          { value: 1, text: '身故' },
          { value: 2, text: '停效' },
          { value: 3, text: '除會' },
          { value: 4, text: '墊繳' },
        ],
      },
      search: {
        class: 0,
        plan: null,
        receive: null,
        bill_type: null,
        member_status: null,
        number: '',
        blur: '',
        sales_number: '',
        sales_ID_number: '',
        // period: '',
        pay_date_S: '',
        pay_date_E: '',
        dead_date_S: '',
        dead_date_E: ''
      },
      status: {
        resetDom: false,
        moreFilter: false,
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "no",
            label: "序號",
          },
          {
            key: "number",
            label: "契約編號",
            sortable: true
          },
          {
            key: "member_name",
            label: "姓名",
            sortable: true
          },
          {
            key: "period",
            label: "帳單期別",
            sortable: true
          },
          {
            key: "type",
            label: "類別",
            sortable: true
          },
          {
            key: "amount",
            label: "互助金",
            sortable: true
          },
          {
            key: "dead_line",
            label: "繳款期限",
            sortable: true
          },
          {
            key: "payment_at",
            label: "繳款日期",
            sortable: true
          },
          {
            key: "payment_source",
            label: "繳費來源",
            sortable: true
          },
          {
            key: "sales_number",
            label: "業務編號",
            sortable: true
          },
          {
            key: "sales_name",
            label: "業務姓名",
            sortable: true
          },
          {
            key: "bill_updated_at",
            label: "異動時間"
          },
          // {
          //   key: "",
          //   label: "建檔帳號"
          // },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_sort: {
          sortBy: 'period',
          sort: 'desc'
        },
        page: {},
        temp_table_data: {}
      },
      billReceiveMethod,
      billType
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.billApi.page);
      this.getBillFlatten();
    },
    countNoNum,
    convertRocDate,
    getBillTypeColor,
    getBillFeeDescription,
    // 查詢帳單
    getBillFlatten(pageIndex = null, sortBy = '', sort = '') {
      if (sortBy) this.data.table_sort.sortBy = sortBy;
      if (sort) this.data.table_sort.sort = sort;

      const params = {
        ...this.search,
        'sortBy': this.data.table_sort.sortBy,
        'sort': this.data.table_sort.sort,
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.billApi.getBillFlatten((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 產生帳單(PDF)
    async generateBill(item = null) {
      this.status.resetDom = true;
      this.data.temp_table_data = Object.assign({}, item);

      await this.$nextTick(); // 等待當前更新週期結束

      this.$refs.htmlToPdf.generatePdf();
    },
    // 重置欄位，並搜尋
    resetSearch() {
      this.search = {
        class: 0,
        plan: null,
        receive: null,
        bill_type: null,
        member_status: null,
        number: '',
        blur: '',
        sales_number: '',
        sales_ID_number: '',
        // period: '',
        pay_date_S: '',
        pay_date_E: '',
        dead_date_S: '',
        dead_date_E: ''
      }

      this.getBillFlatten(1);
    },
    // PDF產生完成
    pdfCompleted () {
      this.$set(this.status, 'resetDom', false);
      this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="file"] {
  display: none;
}

.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/payDetails.vue